import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import * as React from 'react';

export function SvgStarOutline() {
  return <StarUnstarredIcon label="" testId="ads-refreshed-icon" />;
}
